import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TypingDots({ color }) {
    return (_jsxs("div", { style: { display: "inline-flex", gap: 4 }, children: [[0, 1, 2].map((i) => (_jsx("span", { style: {
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: color,
                    opacity: 0.8,
                    animation: "chatdot 1s infinite",
                    animationDelay: `${i * 0.15}s`,
                } }, i))), _jsx("style", { children: `@keyframes chatdot { 0% { transform: translateY(0); opacity: 0.4; } 50% { transform: translateY(-3px); opacity: 1; } 100% { transform: translateY(0); opacity: 0.4; } }` })] }));
}
